import React from "react";
// import classNames from "classnames";
// import Nouislider from "react-nouislider";
import PropTypes from "prop-types";
import numeral from 'numeral';
import moment from 'moment';
import Datetime from "react-datetime";
import Autosuggest from 'react-autosuggest';
// import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
// import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import withStyles from "@material-ui/core/styles/withStyles";
// import Checkbox from "@material-ui/core/Checkbox";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Snackbar from '@material-ui/core/Snackbar';
import FormControl from "@material-ui/core/FormControl";

import Check from "@material-ui/icons/Check";

import Accordion from "../../../components/Accordion/Accordion.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardHeader from "../../../components/Card/CardHeader.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";
import Clearfix from "../../../components/Clearfix/Clearfix.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput";
import Info from "../../../components/Typography/Info";
import IconsServices from "../../../components/common/IconsServices";

import vecLogo from "../../../assets/img/Header-Logo.png";

import styles from "../../../assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.jsx";

import CustomNotification from "../../LandingPage/Sections/CustomNotification";
import SectionFiltered from "./SectionFiltered";

import { filterAccommodations, clearFilter } from "../../../actions/filterActions";
import { STATICS_URL } from '../../../config/constants';

const yesterday = Datetime.moment().subtract( 1, 'day' );
const nextYear = moment().add(1, 'year').get('year');
const endLimitDate = Datetime.moment(`02/01/${nextYear}`, 'DD/MM/YYYY');
const validDate = function( current ){
    return current.isAfter( yesterday ) && current.isBefore( endLimitDate );
};

const locations = [
    { id:'5ba2aba4f976b83038bc5268', city: 'Arcabuco', department: "Boyacá", img: 'https://image.ibb.co/iHAF5q/Arcabuco-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc5289', city: 'Gachantivá', department: "Boyacá", img: 'https://image.ibb.co/iW4a5q/Gachantiva-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52a5', city: 'Paipa', department: "Boyacá", img: 'https://image.ibb.co/dm98Qq/Paipa-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52b0', city: 'Ráquira', department: "Boyacá", img: 'https://image.ibb.co/i3Hv5q/Raquira-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52cb', city: 'Sutamarchán', department: "Boyacá", img: 'https://image.ibb.co/epV4yA/Sutamarchan-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52de', city: 'Villa de Leyva', department: "Boyacá", img: 'https://image.ibb.co/cQPmBV/Villa-de-Leyva-48x48.jpg' }
];
// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const getSuggestions = value => {
    const escapedValue = escapeRegexCharacters(value.trim());
    const regex = new RegExp('\\b' + escapedValue, 'i');
    return locations.filter(locat =>
        regex.test(getSuggestionValue(locat))
    )
};
function getSuggestionValue(suggestion) {
    return `${suggestion.city}`;
}
function renderSuggestion(suggestion, { query }) {
    // const suggestionText = `${suggestion.city} (${suggestion.department})`;
    // const matches = AutosuggestHighlightMatch(suggestionText, query);
    // const parts = AutosuggestHighlightParse(suggestionText, matches);
    return (
        <span className='suggestion-content' style={{ backgroundImage: `url(${suggestion.img})` }}>
            <span className="name">
                {/* {
                    parts.map((part, index) => {
                        const className = part.highlight ? 'highlight' : null;

                        return (
                            <span className={className} key={index}>{part.text}</span>
                        );
                    })
                } */}
            </span>
        </span>
    );
}

class SectionCatalog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            location: '',
            checkIn: '',  // Siempre debe ser un moment
            checkOut: '',  // Siempre debe ser un moment
            numPersons: '',
            suggestions: [],
            openDatePicker: false,
            checked: [],
            priceRange: [25000, 500000],
            errors: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!!localStorage.getItem('FILTERS')) {
            let filters = JSON.parse(localStorage.getItem('FILTERS'));

            if (nextProps.filtersReducer.filteredAccommodations.length===0 && filters.showNotification===true && !!filters.location) {
                this.handleClickNotification('No encontramos alojamientos que cumplan los criterios de busqueda. Por favor intenta con datos diferentes', 'warning');
            } else {
                this.handleClickNotification('Alojamientos filtrados exitosamente', 'success');
            }

            setTimeout(() => {
                filters.showNotification = false;
                localStorage.setItem('FILTERS', JSON.stringify(filters));
            }, 3000);
        }
    }

    componentDidMount() {
        const { filteredAccommodations } = this.props.filtersReducer;

        if (
            !!localStorage.getItem('FILTERS')
            && JSON.parse(localStorage.getItem('FILTERS')).showNotification===true
            && filteredAccommodations.length===0
            && !!JSON.parse(localStorage.getItem('FILTERS')).location
        ) {
            this.handleClickNotification('No encontramos alojamientos que cumplan los criterios de busqueda. Por favor intenta con datos diferentes', 'warning');
            let filters = JSON.parse(localStorage.getItem('FILTERS'));
            setTimeout(() => {
                filters.showNotification = false;
                localStorage.setItem('FILTERS', JSON.stringify(filters));
            }, 3000);
        }

        if (!!localStorage.getItem('FILTERS')) {
            let filters = JSON.parse(localStorage.getItem('FILTERS'));
            if (!!filters.location) {
                if (filters.full_lease===true) this.handleToggle(1);
                this.setState({ location: filters.location, checkIn: moment(filters.checkIn), checkOut: moment(filters.checkOut), numPersons: filters.numPersons });
            }
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    // onChangeSlide = () => {
    //     if (this.refs.NoUiSlider) {
    //         let newArray = this.refs.NoUiSlider.slider.get();
    //         newArray[0] = Number(newArray[0].slice(0, 3));
    //         newArray[1] = Number(newArray[1].slice(0, 3));
    //         let currencyLow = this.refs.priceLow.dataset.currency;
    //         let currencyHigh = this.refs.priceLow.dataset.currency;
    //         this.refs.priceLow.innerHTML = currencyLow + newArray[0];
    //         this.refs.priceHigh.innerHTML = currencyHigh + newArray[1];
    //     }
    // };

    handleToggle(value) {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        currentIndex===-1 ? newChecked.push(value) : newChecked.splice(currentIndex, 1);

        this.setState({ checked: newChecked });
    }

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    /* Suggestions functions */
    onChangeSuggestion = (event, { newValue }) => {
        this.setState({ location: newValue });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({ suggestions: getSuggestions(value) });
    };

    onSuggestionsClearRequested = () => {
        this.setState({ suggestions: [] });
    };

    shouldRenderSuggestions = value => {
        return value.length>=0;
    };

    // renderSuggestionsContainer({ containerProps, children, query }) {
    //     return (
    //         <div {... containerProps}>
    //             {children}
    //         </div>
    //     );
    // }
    /* End Suggestions functions */

    onChangeDateInput = (inputName, e) => {
        if (!!e && !!inputName) {
            this.setState({ [inputName]: e, errors: {}, openDatePicker: false });
        } else {
            this.setState({ [inputName]: '', errors: {}, openDatePicker: false });
        }
    };

    onSubmit = e => {
        e.preventDefault();

        const { location, checkIn, checkOut, numPersons, checked } = this.state;

        let auxNumPersons = (numPersons<=0) ? 1 : numPersons;

        if (location!=='') {
            if (checkIn!=='' || checkOut!=='') {
                if (checkIn.isBefore(checkOut)) {

                    if (!!locations.find(x => x.city === location)) {
                        let filterData = {
                            location: locations.find(x => x.city === location).id,
                            checkIn: checkIn.format("DD")+"%2F"+checkIn.format("MM")+"%2F"+checkIn.format("YYYY"),
                            checkOut: checkOut.format("DD")+"%2F"+checkOut.format("MM")+"%2F"+checkOut.format("YYYY"),
                            numPersons: auxNumPersons,
                            full_lease: (checked.length>0)
                        };

                        localStorage.setItem('FILTERS', JSON.stringify({full_lease: filterData.full_lease, numPersons: filterData.numPersons, location, checkIn, checkOut, showNotification: true}));
                        this.props.filterAccommodations(filterData);
                    } else {
                        this.handleClickNotification('En el momento no tenemos alojamientos en el municipio especificado. Por favor intenta con uno diferente', 'error');
                    }

                } else {
                    let errors = {
                        checkIn: "Fecha no válida",
                        checkOut: "Fecha no válida"
                    };
                    this.setState({ errors });
                    this.handleClickNotification('El Check-In debe ser anterior al Check-Out', 'warning');
                }
            } else {
                this.handleClickNotification('Selecciona las fechas de CheckIn y CheckOut', 'warning');
                let errors = {
                    checkIn: "Selecciona una fecha",
                    checkOut: "Selecciona una fecha"
                };
                this.setState({ errors });
            }
        } else {
            this.handleClickNotification('Selecciona un municipio', 'warning');
            let errors = { location:"Selecciona un municipio" };
            this.setState({ errors });
        }
    };

    render() {
        const { classes, accommodations, filtersReducer } = this.props;

        const { suggestions, errors } = this.state;

        let accommodationCard = (
            accommodations.map(accomm =>
                <GridItem md={12} sm={12} key={accomm._id}>
                    <Card plain blog className={classes.card}>
                        <GridContainer>
                            <GridItem xs={5} sm={5} md={4} className={classes.vecImgContainer}>
                                <CardHeader image plain>
                                    {/**
                                     TODO: Revisar asunto slugs para URL del alojamiento
                                     */}
                                    <Link to={`/accommodation/${accomm._id}`}>
                                        <img
                                            className={classes.vecImg}
                                            src={accomm.photos.length>0 ? STATICS_URL+accomm.photos[0].path : vecLogo}
                                            alt={accomm.name}
                                        />
                                    </Link>
                                    {/* Shadow img */}
                                    {accomm.photos.length>0 ?
                                        <div
                                            className={classes.coloredShadow+" "+classes.vecImg}
                                            style={{ backgroundImage: `url(${accomm.photos.length>0 ? STATICS_URL+accomm.photos[0].path : vecLogo})`, opacity: 1 }}
                                        />
                                        :
                                        null
                                    }
                                    {/* End Shadow img */}
                                </CardHeader>
                            </GridItem>

                            <GridItem xs={7} sm={7} md={6}>
                                <Link to={`/accommodation/${accomm._id}`}>
                                    <h3 className={classes.cardTitle}>{accomm.name}</h3>
                                </Link>
                                <Info>
                                    <h6 className={classes.cardCategory}>{accomm.location.address}, {accomm.location.city}, {accomm.location.department}</h6>
                                </Info>

                                <ul className={classes.vecUlLeft}>
                                    {accomm.services.map( (serv, idx) => {
                                        return <IconsServices serv={serv} key={idx} tooltipClasses={classes.tooltip} />
                                    })}
                                </ul>

                                <p className={classes.author}>Mínimo de huéspedes: {accomm.min_persons}</p>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={2}>
                                {isMobile ?
                                    <div className={classes.vecPriceContainer}>
                                        <GridContainer>
                                            <GridItem xs={8} sm={8} md={8}>
                                                <span>Desde</span>
                                                {(!!accomm.pricing && accomm.pricing.low_season) ?
                                                    <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(accomm.pricing.low_season).format('0,0')}</h3>
                                                    :
                                                    (!!accomm.rooms && accomm.rooms.length>0 && !!accomm.rooms[0].pricing && !!accomm.rooms[0].pricing.low_season) ?
                                                        <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(accomm.rooms[0].pricing.low_season).format('0,0')}</h3>
                                                        :
                                                        null
                                                }
                                                <div>
                                                    {accomm.full_lease===true ?
                                                        <span>Alojamiento completo (IVA no incl.)</span>
                                                        :
                                                        <span>Noche por persona (IVA no incl.)</span>
                                                    }
                                                </div>
                                            </GridItem>
                                            <GridItem xs={4} sm={4} md={4}>
                                                <br/>
                                                <Link to={`/accommodation/${accomm._id}`}>
                                                    <Button color="success">
                                                        Elegir
                                                    </Button>
                                                </Link>
                                            </GridItem>
                                        </GridContainer>
                                    </div>
                                    :
                                    <div className={classes.vecPriceContainer}>
                                        <span>Desde</span>
                                        {(!!accomm.pricing && accomm.pricing.low_season) ?
                                            <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(accomm.pricing.low_season).format('0,0')}</h3>
                                            :
                                            (!!accomm.rooms && accomm.rooms.length>0 && !!accomm.rooms[0].pricing && !!accomm.rooms[0].pricing.low_season) ?
                                                <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(accomm.rooms[0].pricing.low_season).format('0,0')}</h3>
                                                :
                                                null
                                        }
                                        <div>
                                            {accomm.full_lease===true ?
                                                <span>Alojamiento completo (IVA no incl.)</span>
                                                :
                                                <span>Noche por persona (IVA no incl.)</span>
                                            }
                                        </div>
                                        <Link to={`/accommodation/${accomm._id}`}>
                                            <Button color="success">
                                                Elegir
                                            </Button>
                                        </Link>
                                    </div>
                                }
                            </GridItem>
                        </GridContainer>
                    </Card>

                    <hr/>
                    <br/>
                    <br/>

                </GridItem>
            )
        );


        return (
            <div>
                <div className={classes.section}>
                    <div className={classes.container}>

                        <GridContainer>
                            {/* Filter search */}
                            <GridItem xs={12} sm={12} md={3} lg={3}>
                                <Card plain>
                                    {/* Custom Notification */}
                                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                                    </Snackbar>
                                    {/* End Custom Notification */}

                                    <CardBody className={classes.cardBodyRefine}>
                                        <form onSubmit={this.onSubmit}>

                                            {/**
                                             TODO: Reactivar el acordeón de filtros
                                             */}
                                            {/*
                                    va dentro del collapses:

                                    {
                                                title: "Rango de Precios",
                                                content: (
                                                    <CardBody className={classes.cardBodyRefine}>
                                                        <span
                                                            ref="priceLow"
                                                            data-currency="COP$"
                                                            className={classNames(
                                                                classes.pullLeft,
                                                                classes.priceSlider
                                                            )}
                                                        >
                                                            COP$ 25000
                                                        </span>
                                                        <span
                                                            ref="priceHigh"
                                                            data-currency="COP$"
                                                            className={classNames(
                                                                classes.pullRight,
                                                                classes.priceSlider
                                                            )}
                                                        >
                                                            COP$ 500000
                                                        </span>
                                                        <div className="slider slider-success">
                                                            <Nouislider
                                                                start={this.state.priceRange}
                                                                connect={true}
                                                                range={{ min: 25000, max: 500000 }}
                                                                onUpdate={this.onChangeSlide}
                                                                ref="NoUiSlider"
                                                            />
                                                        </div>
                                                    </CardBody>
                                                )
                                            },

                                            {
                                                title: "Calificación",
                                                content: (
                                                    <div className={classes.customExpandPanel}>
                                                        <div
                                                            className={
                                                                classes.checkboxAndRadio +
                                                                " " +
                                                                classes.checkboxAndRadioHorizontal
                                                            }
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(27)}
                                                                        checked={
                                                                            this.state.checked.indexOf(27) !== -1
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="All"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(28)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Black"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(29)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Blue"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(30)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Brown"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(31)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Gray"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(32)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Green"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(33)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Neutrals"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(34)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Purple"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            },
                                            {
                                                title: "Servicios",
                                                content: (
                                                    <div className={classes.customExpandPanel}>
                                                        <div
                                                            className={
                                                                classes.checkboxAndRadio +
                                                                " " +
                                                                classes.checkboxAndRadioHorizontal
                                                            }
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(27)}
                                                                        checked={
                                                                            this.state.checked.indexOf(27) !== -1
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="All"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(28)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Black"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(29)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Blue"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(30)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Brown"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(31)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Gray"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(32)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Green"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(33)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Neutrals"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(34)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Purple"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                    */}

                                            {isMobile ?
                                                <Accordion
                                                    active={[]}
                                                    activeColor="success"
                                                    collapses={[
                                                        {
                                                            title: "Destino",
                                                            content: (
                                                                <div className="filter-bar">
                                                                    <Autosuggest
                                                                        id="location"
                                                                        suggestions={suggestions}
                                                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                        getSuggestionValue={getSuggestionValue}
                                                                        renderSuggestion={renderSuggestion}
                                                                        // renderSuggestionsContainer={this.renderSuggestionsContainer}
                                                                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                                                                        inputProps={{
                                                                            placeholder: 'Ingresa una ciudad',
                                                                            value: this.state.location,
                                                                            onChange: this.onChangeSuggestion
                                                                        }}
                                                                    />
                                                                </div>
                                                            )
                                                        },
                                                        {
                                                            title: "Fechas",
                                                            content: (
                                                                <div className="date-input-spaced">
                                                                    <Datetime
                                                                        id="checkIn"
                                                                        value={this.state.checkIn}
                                                                        closeOnSelect={true}
                                                                        closeOnTab={true}
                                                                        className={classes.compressedInput}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        timeFormat={false}
                                                                        isValidDate={ validDate }
                                                                        onChange={ e => this.onChangeDateInput("checkIn", e) }
                                                                        inputProps={{
                                                                            placeholder: "Check-In",
                                                                            name: "checkIn",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.checkIn ? errors.checkIn : null}</small>

                                                                    <Datetime
                                                                        id="checkOut"
                                                                        value={this.state.checkOut}
                                                                        closeOnSelect={true}
                                                                        closeOnTab={true}
                                                                        className={classes.compressedInput}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        timeFormat={false}
                                                                        isValidDate={ validDate }
                                                                        onChange={ e => this.onChangeDateInput("checkOut", e) }
                                                                        inputProps={{
                                                                            placeholder: "Check-Out",
                                                                            name: "checkOut",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.checkOut ? errors.checkOut : null}</small>
                                                                </div>
                                                            )
                                                        },
                                                        {
                                                            title: "Datos hospedaje",
                                                            content: (
                                                                <div>
                                                                    <CustomInput
                                                                        id = "numPersons"
                                                                        formControlProps={{ fullWidth: true, className: classes.compressedInput3 }}
                                                                        inputProps={{
                                                                            type: "number",
                                                                            value: this.state.numPersons,
                                                                            onChange: this.onChangeCustomInput(),
                                                                            placeholder: "Num. Huéspedes",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.numPersons ? errors.numPersons : null}</small>

                                                                    <div className={classes.compressedInput}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    onClick={ () => this.handleToggle(1) }
                                                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                                                    classes={{ checked: classes.checked }}
                                                                                    checked={ this.state.checked.indexOf(1) !== -1 }/>
                                                                            }
                                                                            classes={{ label: classes.label }}
                                                                            label="Aloj. completo"
                                                                        />
                                                                    </div>
                                                                    <small className={classes.errorDisplay}>{!!errors.full_lease ? errors.full_lease : null}</small>
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />

                                                :

                                                <div>
                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <Autosuggest
                                                            id="location"
                                                            suggestions={suggestions}
                                                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                            getSuggestionValue={getSuggestionValue}
                                                            renderSuggestion={renderSuggestion}
                                                            // renderSuggestionsContainer={this.renderSuggestionsContainer}
                                                            shouldRenderSuggestions={this.shouldRenderSuggestions}
                                                            inputProps={{
                                                                placeholder: 'Ingresa una ciudad',
                                                                value: this.state.location,
                                                                onChange: this.onChangeSuggestion
                                                            }}
                                                        />
                                                    </FormControl>

                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <Datetime
                                                            id="checkIn"
                                                            value={this.state.checkIn}
                                                            closeOnSelect={true}
                                                            closeOnTab={true}
                                                            className={classes.compressedInput}
                                                            dateFormat="DD/MM/YYYY"
                                                            timeFormat={false}
                                                            isValidDate={ validDate }
                                                            onChange={ e => this.onChangeDateInput("checkIn", e) }
                                                            inputProps={{
                                                                placeholder: "Check-In",
                                                                name: "checkIn",
                                                                autoComplete: "off"
                                                            }}
                                                        />
                                                        <small className={classes.errorDisplay}>{!!errors.checkIn ? errors.checkIn : null}</small>
                                                    </FormControl>

                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <Datetime
                                                            id="checkOut"
                                                            value={this.state.checkOut}
                                                            closeOnSelect={true}
                                                            closeOnTab={true}
                                                            className={classes.compressedInput}
                                                            dateFormat="DD/MM/YYYY"
                                                            timeFormat={false}
                                                            isValidDate={ validDate }
                                                            onChange={ e => this.onChangeDateInput("checkOut", e) }
                                                            inputProps={{
                                                                placeholder: "Check-Out",
                                                                name: "checkOut",
                                                                autoComplete: "off"
                                                            }}
                                                        />
                                                        <small className={classes.errorDisplay}>{!!errors.checkOut ? errors.checkOut : null}</small>
                                                    </FormControl>

                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <CustomInput
                                                            id = "numPersons"
                                                            formControlProps={{ fullWidth: true, className: classes.compressedInput3 }}
                                                            inputProps={{
                                                                type: "number",
                                                                value: this.state.numPersons,
                                                                onChange: this.onChangeCustomInput(),
                                                                placeholder: "Num. Huéspedes",
                                                                autoComplete: "off"
                                                            }}
                                                        />
                                                        <small className={classes.errorDisplay}>{!!errors.numPersons ? errors.numPersons : null}</small>
                                                    </FormControl>

                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <div className={classes.compressedInput}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        onClick={ () => this.handleToggle(1) }
                                                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                                                        icon={<Check className={classes.uncheckedIcon} />}
                                                                        classes={{ checked: classes.checked }}
                                                                        checked={ this.state.checked.indexOf(1) !== -1 }/>
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Aloj. completo"
                                                            />
                                                        </div>
                                                        <small className={classes.errorDisplay}>{!!errors.full_lease ? errors.full_lease : null}</small>
                                                    </FormControl>
                                                </div>
                                            }

                                            <h4 className={`${classes.cardTitle} ${classes.textLeft}`}>
                                                <Button color="success" type="submit">
                                                    Filtrar
                                                </Button>
                                                <Clearfix />
                                            </h4>

                                        </form>
                                    </CardBody>
                                </Card>
                            </GridItem>
                            {/* End Filter search */}
                            {/* Products catalog */}
                            <GridItem xs={12} sm={12} md={9} lg={9}>

                                {filtersReducer.filteredAccommodations.length>0 ?
                                    <SectionFiltered />
                                    :
                                    null
                                }

                                {filtersReducer.filteredAccommodations.length>0 ?
                                    <div>
                                        <br/>
                                        <hr/>
                                        <h2>También te puede interesar:</h2>
                                    </div>
                                    :
                                    <h2>Catálogo</h2>
                                }

                                <GridContainer>
                                    {/* Product card */}
                                    {accommodationCard}
                                    {/* End Product card */}

                                    {/*<GridItem
                                    md={12}
                                    sm={12}
                                    className={classNames(classes.mlAuto, classes.mrAuto)}
                                >
                                    <Button round color="success">
                                        Cargar más
                                    </Button>
                                </GridItem>*/}
                                </GridContainer>
                            </GridItem>
                            {/* End Products catalog */}
                        </GridContainer>
                    </div>
                </div>
            </div>
        );
    }
}

SectionCatalog.propTypes = {
    filterAccommodations: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    filtersReducer: PropTypes.object
};

const mapStateToProps = state => ({
    filtersReducer: state.filtersReducer
});

export default connect(mapStateToProps, { filterAccommodations, clearFilter })( withStyles(styles)(SectionCatalog) );



// WEBPACK FOOTER //
// ./src/views/AccommodationsPage/Sections/SectionCatalog.jsx